var _a;
var keys = {
    gadventures: "gadventures",
    viator: "viator",
};
export var partnerActivityProviders = (_a = {},
    _a[keys.gadventures] = {
        id: keys.gadventures,
        name: "G Adventures",
    },
    _a[keys.viator] = {
        id: keys.viator,
        name: "Viator",
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/partnerActivityProviders.ts
// module id = Bz8k
// module chunks = 2